export const money = (n) => {
    if (n == null || !Number.isFinite(Number(n))) return "—";
    return Number(n).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
    });
};

export const toIsoDate = (date) => {
    if (!date) return undefined;
    const d = new Date(date);
    const tzOffsetMs = d.getTimezoneOffset() * 60000;
    return new Date(d.getTime() - tzOffsetMs).toISOString().slice(0, 10);
};

export const accountFromSearchParams = (params) => {
    const accountKey = params.get("accountKey");
    if (!accountKey) return null;
    const key = Number(accountKey);
    if (!Number.isFinite(key)) return null;
    const hcc = params.get("accountHccId") || "";
    const name = params.get("accountName") || "";
    const label = name && hcc
        ? `${name} (${hcc} | ${key})`
        : name || hcc || `Account ${key}`;
    return {
        value: key,
        label,
        additional: {
            accountKey: key,
            accountHccId: hcc || undefined,
            accountName: name || undefined,
        },
    };
};

export const accountQueryString = (account, extra = {}) => {
    const params = new URLSearchParams();
    const key = account?.additional?.accountKey;
    if (key) params.set("accountKey", String(key));
    if (account?.additional?.accountHccId) {
        params.set("accountHccId", account.additional.accountHccId);
    }
    if (account?.additional?.accountName) {
        params.set("accountName", account.additional.accountName);
    }
    for (const [k, v] of Object.entries(extra)) {
        if (v != null && v !== "") params.set(k, String(v));
    }
    const qs = params.toString();
    return qs ? `?${qs}` : "";
};

export const writeAccountParams = (searchParams, opt) => {
    const next = new URLSearchParams(searchParams);
    if (opt?.additional?.accountKey) {
        next.set("accountKey", String(opt.additional.accountKey));
        if (opt.additional.accountHccId) next.set("accountHccId", opt.additional.accountHccId);
        else next.delete("accountHccId");
        if (opt.additional.accountName) next.set("accountName", opt.additional.accountName);
        else next.delete("accountName");
    } else {
        next.delete("accountKey");
        next.delete("accountHccId");
        next.delete("accountName");
    }
    return next;
};

export const writePlanParams = (searchParams, plan) => {
    const next = new URLSearchParams(searchParams);
    if (plan?.value != null) {
        next.set("planKey", String(plan.value));
        const hcc = plan.additional?.hccId;
        const name = plan.additional?.name;
        if (hcc) next.set("planHccId", hcc);
        else next.delete("planHccId");
        if (name) next.set("planName", name);
        else next.delete("planName");
    } else {
        next.delete("planKey");
        next.delete("planHccId");
        next.delete("planName");
    }
    return next;
};
